import React, { FC } from "react";
import { Button, ButtonProps } from "antd";
import styles from "./avelios-button.module.scss";

export const AveliosButton: FC<ButtonProps> = ({ ...props }) => {
  return <Button className={styles.aveliosButton} {...props} />;
};
